<template>
    <footer
        :class="{
            'mt-12': !isFrontPage,
        }"
        class="style-title-2 max-sm:mt-8"
    >
        <div class="max-w-5xl mx-auto w-full my-8 px-6">
            <p class="m-0 text-center">
                <nuxt-link :href="localePath('/faq')">{{ $t("layouts.footer.faq") }}</nuxt-link
                >&nbsp;| <nuxt-link :href="localePath('/cms/imprint')">{{ $t("layouts.footer.imprint") }}</nuxt-link
                >&nbsp;|
                <nuxt-link :href="localePath('/cms/privacy-policy')">{{ $t("layouts.footer.privacy") }}</nuxt-link
                >&nbsp;|
                <nuxt-link
                    v-if="isFoth"
                    :href="localePath('/cms/terms-friends-of-the-houses')"
                    >{{ $t("layouts.footer.terms-loyalty") }}</nuxt-link
                >
                <nuxt-link
                    v-else
                    :href="localePath('/cms/terms-loyalty-card-programm')"
                    >{{ $t("layouts.footer.terms-loyalty") }}</nuxt-link
                >
                - <span class="whitespace-nowrap">{{ $t("layouts.footer.copyright", { year: currentYear }) }}</span>
            </p>
        </div>
    </footer>
</template>

<script lang="ts" setup>
const route = useRoute();
const localePath = useLocalePath();

const currentYear = new Date().getFullYear();

const isFrontPage = computed(() => route.path === localePath("/"));

const { isFoth } = useFoth();
</script>
